import { SectionContainer } from './styles';

interface Props {
  title: string;
  subTitle: string;
  backgroundImgUrl?: string;
  sectionHeight?: number;
  children?: React.ReactNode;
  className?: string;
}

export const SectionLayout = (props: Props) => {
  const { title, subTitle, backgroundImgUrl, sectionHeight, children, className } = props;

  return (
    <SectionContainer className={className} backgroundImg={backgroundImgUrl} height={sectionHeight}>
      <h2>{title}</h2>
      <h4>{subTitle}</h4>
      {children}
    </SectionContainer>
  );
};
